<template>
  <div :class="{ 'p-p-4': !openedInDialog }">
    <div v-if="itemLocal">
      <div class="p-d-flex p-flex-column" v-if="!BID">
        <span>{{ __("Building") }}:</span>
        <p-vue-dropdown
          :options="BuildingsOptions"
          :optionLabel="'Build'"
          :filter="BuildingsOptions.length > 10"
          v-model="itemLocal.BIDValue"
          class="dropdown"
          @change="BuildingSelected"
          :disabled="isEdit"
          id="BID"
        >
          <template #value="{ value, placeholder}">
            <div class="inner p-d-flex p-jc-between">
              <span class="value">{{ value ? value.Build : placeholder }}</span>
              <span class="icon">
                <i-icon name="arrow" />
              </span>
            </div>
          </template>
        </p-vue-dropdown>
        <i-form-error :data="errors.BID" />
      </div>
      <div v-if="itemLocal.BID">
        <div class="p-d-flex p-flex-column p-pt-2">
          <span>{{ __("Unit") }}:</span>
          <p-vue-dropdown
            :options="UnitsOptions"
            :optionLabel="'Number'"
            :filter="UnitsOptions.length > 10"
            v-model="itemLocal.UIDValue"
            class="dropdown"
            id="UID"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.Number : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
          <i-form-error :data="errors.UID" />
        </div>

        <div class="p-d-flex p-flex-column p-pt-2" v-if="itemLocal.UIDValue">
          <span>{{ __("Sent by") }}:</span>
          <!-- <p-vue-dropdown
            :options="itemLocal.UIDValue?.Contacts"
            :optionLabel="'Name'"
            :filter="itemLocal.UIDValue?.Contacts > 10"
            v-model="itemLocal.ContactIDFromValue"
            class="dropdown"
            @change="ContactFromSelected"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.Name : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown> v-if="itemLocal.ContactIDFromValue" -->
          <div class="p-px-4">
            <div class="p-d-flex p-flex-column p-pt-2">
              <span>{{ __("Name") }}:</span>
              <p-vue-input-text v-model="itemLocal.NameFrom" id="NameFrom" />
              <i-form-error :data="errors.NameFrom" />
            </div>
            <div class="p-d-flex p-flex-column p-pt-2">
              <span>{{ __("Phone") }}:</span>
              <p-vue-input-text v-model="itemLocal.PhoneFrom" id="PhoneFrom" />
              <i-form-error :data="errors.PhoneFrom" />
            </div>
            <div class="p-d-flex p-flex-column p-pt-2">
              <span>{{ __("Email") }}:</span>
              <p-vue-input-text v-model="itemLocal.EmailFrom" id="EmailFrom" />
              <i-form-error :data="errors.EmailFrom" />
            </div>
          </div>
        </div>
        <div class="p-d-flex p-flex-column p-pt-2" v-if="itemLocal.UIDValue">
          <span>{{ __("Recipient") }}:</span>
          <p-vue-dropdown
            :options="itemLocal.UIDValue?.Contacts"
            :optionLabel="'Name'"
            :filter="itemLocal.UIDValue?.Contacts > 10"
            v-model="itemLocal.ContactIDToValue"
            class="dropdown"
            @change="ContactToSelected"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.Name : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
          <div class="p-px-4" v-if="itemLocal.ContactIDToValue">
            <div class="p-d-flex p-flex-column p-pt-2">
              <span>{{ __("Name") }}:</span>
              <p-vue-input-text v-model="itemLocal.NameTo" id="NameTo" />
              <i-form-error :data="errors.NameTo" />
            </div>
            <div class="p-d-flex p-flex-column p-pt-2">
              <span>{{ __("Phone") }}:</span>
              <p-vue-input-text v-model="itemLocal.PhoneTo" id="PhoneTo" />
              <i-form-error :data="errors.PhoneTo" />
            </div>
            <div class="p-d-flex p-flex-column p-pt-2">
              <span>{{ __("Email") }}:</span>
              <p-vue-input-text v-model="itemLocal.EmailTo" id="EmailTo" />
              <i-form-error :data="errors.EmailTo" />
            </div>
          </div>
        </div>
        <div class="p-d-flex p-flex-column p-pt-2">
          <span>{{ __("Comment") }}:</span>
          <p-vue-input-text
            v-model="itemLocal.CommentAccepted"
            id="CommentAccepted"
          />
          <i-form-error :data="errors.Comment" />
        </div>
        <div class="p-d-flex p-flex-column p-pt-2" v-if="!IsKeyLocal">
          <span>{{ __("Type") }}:</span>
          <p-vue-dropdown
            :options="TypesOptions"
            :optionLabel="'Name'"
            :filter="TypesOptions.length > 10"
            v-model="itemLocal.TypeValue"
            class="dropdown"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? __(value.Name) : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
          <div
            class="p-px-4 p-d-flex p-flex-column p-pt-2"
            v-if="itemLocal.TypeValue?.ID == 3"
          >
            <span>{{ __("please specify") }}:</span>
            <p-vue-input-text v-model="itemLocal.TypeDesc" id="Type" />
          </div>
          <i-form-error :data="errors.Type" />
        </div>

        <div class="p-d-flex p-flex-column p-pt-2">
          <span>{{ __("Storage Location") }}:</span>
          <p-vue-dropdown
            v-if="StorageLocationOptions.length > 1"
            :options="StorageLocationOptions"
            :optionLabel="'StorageLocation'"
            :filter="StorageLocationOptions.length > 10"
            v-model="itemLocal.StorageLocationValue"
            class="dropdown"
            @change="StorageLocationSelected"
            id="StorageLocation"
          >
            <template #value="{ value, placeholder}">
              <div class="inner p-d-flex p-jc-between">
                <span class="value">{{
                  value ? value.StorageLocation : placeholder
                }}</span>
                <span class="icon">
                  <i-icon name="arrow" />
                </span>
              </div>
            </template>
          </p-vue-dropdown>
          <div
            :class="{
              'p-px-4 p-pt-2': StorageLocationOptions.length > 1,
              'p-d-flex p-flex-column': true,
            }"
            v-if="
              StorageLocationOptions.length == 1 ||
                itemLocal.StorageLocationValue?.StorageLocation == 'אחר'
            "
          >
            <span
              v-if="itemLocal.StorageLocationValue?.StorageLocation == 'אחר'"
              >{{ __("please specify") }}:</span
            >
            <p-vue-input-text v-model="itemLocal.StorageLocationDesc" />
          </div>
          <i-form-error :data="errors.StorageLocation" />
        </div>

        <!-- תמונה -->
        <div>
          <div class="upload-button p-mt-4" @click="addImage">
            <span
              class="p-button-icon p-button-icon-left pi pi-fw pi-plus"
            ></span>
            {{ __("Add an image") }}
          </div>
          <p-vue-file-upload
            url="./"
            accept="image/*"
            class="upload-button"
            style="display: none;"
            :multiple="false"
            :customUpload="true"
            :showCancelButton="false"
            :showUploadButton="false"
            :chooseLabel="__('Add an image')"
            :invalidFileLimitMessage="
              __('Maximum number of files exceeded, limit is {0} at most.')
            "
            :invalidFileSizeMessage="
              __(
                '{0}: Invalid file size, file size should be smaller than {1}.'
              )
            "
            v-model="attachments"
            ref="Upload"
          />
          <div class="upload-preview">
            <ul>
              <li v-for="(file, index) in attachments" :key="index">
                <!-- <img :src="getSrc(file)" /> -->
                <img :src="file" />
                <p-vue-button
                  class="p-button-danger p-button-sm p-button-rounded"
                  @click.prevent="doTrashAttachment(index)"
                >
                  <i-icon name="trash" />
                </p-vue-button>
              </li>
            </ul>
          </div>
          <p-get-image
            v-if="getImage"
            @getImage="getPictureLocal"
          ></p-get-image>
        </div>
        <!-- שליחת הודעה -->
        <div class="">
          <div class="p-mt-2">
            <p-vue-checkbox :binary="true" v-model="sendSMS" id="SendMessage" />
            <label class="p-mr-2">
              {{ __("Send a message via SMS") }}
            </label>
          </div>
          <div class="p-mt-3">
            <p-vue-checkbox :binary="true" v-model="sendEmail" />
            <label class="p-mr-2">
              {{ __("Send a message by email") }}
            </label>
          </div>
        </div>
        <i-form-error :data="errors.SendMessage" />
      </div>
      <div class="p-d-flex p-jc-between p-mt-4">
        <p-vue-button
          class="button p-button-rounded p-button-success max-width"
          :label="__('Save')"
          @click="saveAndSentMessage"
          :disabled="!itemLocal.BID"
        />
        <p-vue-button
          class="button p-button-rounded p-button-success max-width"
          :label="__('Cancel')"
          @click="cancle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n/";
import {
  errorReceived,
  isValidEmail,
  isValidPhoneNumber,
  showSuccessOrFailedModal,
} from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import { getPicture } from "../../services/UploadFilesService";
import { uploadB64 } from "../../services/APointAPI";
import PGetImage from "@/components/partials/p-get-image";

export default {
  components: {
    PGetImage,
  },
  props: {
    item: Object,
    close: Function,
    IsKey: { Type: Boolean, default: false },
    isEdit: Boolean,
    openedInDialog: { Type: Boolean, default: false },
  },
  emits: ["itemUpdate"],
  data() {
    return {
      itemLocal: {},
      UnitsOptions: [],
      ContactsOptions: [],
      BuildingsOptions: [],
      StorageLocationOptions: [],
      TypesOptions: [],
      IsKeyLocal: false,
      errors: { Company: null, Email: null, SSID: null, GroupID: null },
      valid: true,
      attachments: [],
      getImage: false,
      filesSentCnt: 0,
      filesUploadSuccessCnt: 0,
      sendSMS: 0,
      sendEmail: 0,
    };
  },
  mounted() {
    if (this.item) {
      this.itemLocal = this.item;
    }

    this.IsKeyLocal = this.IsKey;
    if (!this.IsKey && this.$route.name == "AddKey") this.IsKeyLocal = true;

    if (!this.BID || this.isEdit) this.getBuildings();
    else {
      this.itemLocal.BID = this.BID;
      this.WorkerApp_DropDownDataToDeliveryItemsByBID();
    }
  },
  methods: {
    getBuildings() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("UserNum", this.userNum, apiPType.Int)];
      callProc("WorkerApp_ListBuildings", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.BuildingsOptions = result.Table;
          if (this.isEdit) {
            this.itemLocal.BIDValue = this.BuildingsOptions.find(
              (b) => b.BID == this.itemLocal.BID
            );
            this.WorkerApp_DropDownDataToDeliveryItemsByBID();
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch((e) => {
          errorReceived("WorkerApp_DropDownDataToProblem", e);
        });
    },
    WorkerApp_DropDownDataToDeliveryItemsByBID() {
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("BID", this.itemLocal.BID, apiPType.Int),
      ];
      callProc("WorkerApp_DropDownDataToDeliveryItemsByBID", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(result);
          this.UnitsOptions = result.Table;
          this.UnitsOptions.forEach((unit) => {
            unit.Contacts = result.Table1.filter((f) => f.UID == unit.UID);
            unit.Contacts.push({ ContactID: -1, Name: "אחר" });
          });
          this.TypesOptions = result.Table2;
          this.StorageLocationOptions = result.Table3;
          this.StorageLocationOptions.push({ StorageLocation: "אחר" });

          if (this.isEdit) {
            this.itemLocal.UIDValue = this.UnitsOptions.find(
              (f) => f.UID == this.itemLocal.UID
            );
            this.itemLocal.ContactIDToValue = this.itemLocal.UIDValue?.Contacts.find(
              (f) => f.ContactID == this.itemLocal.ContactIDTo
            );
            this.itemLocal.ContactIDFromValue = this.itemLocal.UIDValue?.Contacts.find(
              (f) => f.ContactID == this.itemLocal.ContactIDFrom
            );
            this.itemLocal.TypeValue = this.TypesOptions.find(
              (f) => f.Name == this.itemLocal.Type
            );
            this.itemLocal.StorageLocationValue = this.StorageLocationOptions.find(
              (f) => f.StorageLocation == this.itemLocal.StorageLocation
            );
            this.StorageLocationSelected();
          }

          this.$store.dispatch("doLoading", false);
        })
        .catch((e) => {
          errorReceived("WorkerApp_DropDownDataToDeliveryItemsByBID", e);
        });
    },
    BuildingSelected() {
      this.itemLocal.BID = this.itemLocal.BIDValue.BID;
      this.WorkerApp_DropDownDataToDeliveryItemsByBID();
    },
    ContactToSelected() {
      if (this.itemLocal.ContactIDToValue.ContactID != -1) {
        this.itemLocal.NameTo = this.itemLocal.ContactIDToValue.Name;
        this.itemLocal.PhoneTo = this.itemLocal.ContactIDToValue.TelMobile;
        this.itemLocal.EmailTo = this.itemLocal.ContactIDToValue.Email;
      } else {
        this.itemLocal.NameTo = null;
        this.itemLocal.PhoneTo = null;
        this.itemLocal.EmailTo = null;
      }
    },
    ContactFromSelected() {
      if (this.itemLocal.ContactIDFromValue.ContactID != -1) {
        this.itemLocal.NameFrom = this.itemLocal.ContactIDFromValue.Name;
        this.itemLocal.PhoneFrom = this.itemLocal.ContactIDFromValue.TelMobile;
        this.itemLocal.EmailFrom = this.itemLocal.ContactIDFromValue.Email;
      } else {
        this.itemLocal.NameFrom = null;
        this.itemLocal.PhoneFrom = null;
        this.itemLocal.EmailFrom = null;
      }
    },
    StorageLocationSelected() {
      if (this.itemLocal.StorageLocationValue.StorageLocation != "אחר")
        this.itemLocal.StorageLocationDesc = this.itemLocal.StorageLocationValue.StorageLocation;
      else this.itemLocal.StorageLocationDesc = "";
    },
    validateFields() {
      this.valid = true;
      this.errors = {};
      if (!this.itemLocal.BIDValue && !this.itemLocal.BID) {
        this.valid = false;
        this.errors.BID = "Required field";
      }
      if (!this.itemLocal.UIDValue) {
        this.valid = false;
        this.errors.UID = "Required field";
      }
      if (!this.IsKeyLocal)
        if (!this.itemLocal.TypeValue) {
          this.valid = false;
          this.errors.Type = "Required field";
        } else if (
          this.itemLocal.TypeValue?.ID == 3 &&
          !this.itemLocal.TypeDesc
        ) {
          this.valid = false;
          this.errors.TypeDesc = "Required field";
        }
      if (!this.itemLocal.NameFrom) {
        this.valid = false;
        this.errors.NameFrom = "Required field";
      }
      // if (!this.itemLocal.StorageLocationValue ) {
      //   this.valid = false;
      //   this.errors.StorageLocation = "Required field";
      // } else
      if (
        // this.itemLocal.StorageLocationValue == "אחר" &&
        !this.itemLocal.StorageLocationDesc
      ) {
        this.valid = false;
        this.errors.StorageLocationDesc = "Required field";
      }
      if (this.IsKeyLocal && !this.itemLocal.NameTo) {
        this.valid = false;
        this.errors.NameTo = "Required field";
      }
      if ((this.IsKeyLocal || this.sendSMS) && !this.itemLocal.PhoneTo) {
        this.valid = false;
        this.errors.PhoneTo = "Required field";
      }
      if (
        this.itemLocal.PhoneTo &&
        !isValidPhoneNumber(this.itemLocal.PhoneTo)
      ) {
        this.valid = false;
        this.errors.PhoneTo = "Invalid phone number";
      }
      if (this.sendEmail && !this.itemLocal.EmailTo) {
        this.valid = false;
        this.errors.EmailTo = "Required field";
      }
      if (this.itemLocal.EmailTo && !isValidEmail(this.itemLocal.EmailTo)) {
        this.valid = false;
        this.errors.EmailTo = "Invalid email address";
      }
      if (
        !this.sendEmail &&
        !this.sendSMS &&
        ((this.isEdit && this.itemLocal.UID != this.itemLocal.UIDValue.UID) ||
          !this.isEdit)
      ) {
        this.valid = false;
        this.errors.SendMessage = "You must select an option to send a message";
      }
    },
    saveAndSentMessage() {
      this.validateFields();
      // console.log(this.errors);
      if (!this.valid) {
        let objectkeys = Object.keys(this.errors);
        let key,
          e,
          i = 0;
        do {
          i++;
          key = objectkeys[i];
          e = document.querySelector("#" + key);
        } while (!e && i < objectkeys.length);
        if (e) e.focus();
        return;
      } else {
        this.$store.dispatch("doLoading", true);
        let procParams = [
          apiParam("ID", this.itemLocal.ID, apiPType.Int),
          apiParam("BID", this.itemLocal.BID, apiPType.Int),
          apiParam("UID", this.itemLocal.UIDValue.UID, apiPType.Int),
          apiParam(
            "ContactIDTo",
            this.itemLocal.ContactIDToValue.ContactID,
            apiPType.Int
          ),
          apiParam(
            "ContactIDFrom",
            0,
            apiPType.Int
          ),
          apiParam("TYPE", this.itemLocal.TypeValue?.ID, apiPType.Int),
          apiParam("TypeDesc", this.itemLocal.TypeDesc, apiPType.Int),
          apiParam("DateAndTimeAccepted", new Date(), apiPType.Datetime),
          apiParam(
            "StorageLocation",
            this.itemLocal.StorageLocationDesc,
            apiPType.NVarChar
          ),
          apiParam("ISKey", this.IsKeyLocal, apiPType.NVarChar),
          apiParam("NameTo", this.itemLocal.NameTo, apiPType.NVarChar),
          apiParam("PhoneTo", this.itemLocal.PhoneTo, apiPType.NVarChar),
          apiParam("EmailTo", this.itemLocal.EmailTo, apiPType.NVarChar),
          apiParam("NameFrom", this.itemLocal.NameFrom, apiPType.NVarChar),
          apiParam("PhoneFrom", this.itemLocal.PhoneFrom, apiPType.NVarChar),
          apiParam("EmailFrom", this.itemLocal.EmailFrom, apiPType.NVarChar),
          apiParam(
            "CommentAccepted",
            this.itemLocal.CommentAccepted,
            apiPType.NVarChar
          ),
          apiParam("sendSMS", !!this.sendSMS, apiPType.Bit),
          apiParam("SendEmail", !!this.sendEmail, apiPType.Bit),
          apiParam("WorkerIDAccepted", this.userNum, apiPType.NVarChar),
        ];
        callProc("WorkerApp_SavingItem", procParams)
          .then((result) => {
            result = JSON.parse(result);
            // console.log(result);
            this.$store.dispatch("doLoading", false);
            // let text = this.IsKeyLocal ? "key" : "item";
            if (result.Table[0].StatusResult == 1 && result.Table[0].ID) {
              if (this.attachments && this.attachments.length > 0)
                this.upload(result.Table[0].ID);
              else {
                this.successSave();
              }
            } else
              errorReceived(
                "WorkerApp_SavingItem",
                result.Table[0].StatusDescription
              );
          })
          .catch(() => {
            errorReceived("WorkerApp_SavingItem");
          });
      }
    },
    addImage() {
      this.getImage = false;
      setTimeout(() => {
        this.getImage = true;
      }, 0);
    },
    getPictureLocal(sourceType) {
      getPicture(sourceType, (obj) => {
        this.getImage = false;
        this.attachments.push(obj);
      });
    },
    doTrashAttachment(index) {
      this.attachments.splice(index, 1);
    },
    upload(ParentID) {
      this.attachments.forEach((att, idx, arr) => {
        uploadB64(
          13,
          ParentID,
          1,
          `SavingMailDetailsAndKeys ${ParentID} - ${idx}.jpeg`,
          att
        )
          .then(() => {
            // console.log(res, idx + 1, arr.length);

            if (idx + 1 === arr.length) {
              this.successSave();
            }
          })
          .catch((error) => {
            errorReceived(
              "WorkerApp_SavingItem",
              error,
              __("An error occurred")
            );
          });
      });
    },
    cancle() {
      if (this.close) {
        this.close();
      } else
        this.$router.push({
          name: "Dashboard",
        });
    },
    successSave() {
      this.$store.dispatch("doLoading", false);
      showSuccessOrFailedModal(__(`Data saved successfully!`));
      let routeName = this.IsKeyLocal ? "Keys" : "MailItems";
      setTimeout(() => {
        this.$router.push({
          name: routeName,
        });
      }, 2000);
      this.close();
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
      BID: (state) => state.api.bID,
    }),
  },
};
</script>

<style scoped>
.p-inputtextarea {
  width: 100%;
}

.icon:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

.grid {
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
}

.upload-button {
  margin-top: 25px;
  display: block;
  width: 100%;
  margin: 0;
  padding: 13px 15px;
  border-radius: 30px;
  background-color: white;
  border: 1px solid var(--color-success);
  color: black;
  font-size: 16px;
  line-height: 1.28;
  letter-spacing: 0.51px;
  text-align: center;
}

.upload-button:deep(.p-button) {
  display: block;

  width: 100%;

  margin: 0;
  padding: 13px 15px;

  border-radius: 30px;
  background-color: white;
  border: 1px solid var(--color-success);

  color: black;
  font-size: 16px;
  line-height: 1.28;
  letter-spacing: 0.51px;
}

.upload-preview ul {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

  margin: 0;
  padding: 15px 0 0 0;

  list-style: none;
}

.upload-preview ul li {
  position: relative;
}

.upload-preview ul li img {
  width: 100%;
  height: 100%;

  object-fit: cover;
}

.upload-preview ul li:deep(.svg) {
  width: 15px;
  height: 15px;
}

.upload-preview ul li:deep(.p-button) {
  top: -5px;
  left: -5px;
  z-index: 2;
  position: absolute;

  padding: 3px;
}
</style>
